// src/pages/ImportPage.jsx
import React, { useState } from "react";
import axios from "../../axios";
import {
  Container,
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  Button,
  MenuItem,
  Typography,
  Alert,
} from "@mui/material";
import { SaveAlt, UploadFile } from "@mui/icons-material";
import * as XLSX from "xlsx";
import API_BASE_URL from "../../config";

export default function ImportPage() {
  // ✅ جلب التوكن من localStorage
  const companyId = parseInt(localStorage.getItem("companyId"), 10);
  const branchId = parseInt(localStorage.getItem("branchId"), 10);

  const [importType, setImportType] = useState(0); // 0 = منتجات
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  // 🟢 رفع الملف
  const handleImport = async () => {
    if (!file) {
      setError("❌ يرجى اختيار ملف Excel أولا");
      return;
    }
    setError(null);
    setMessage(null);

    try {
      const formData = new FormData();
      formData.append("File", file); // ✅ مطابق للـ API
      formData.append("CompanyId", companyId);
      formData.append("BranchId", branchId);

      const res = await axios.post(
        `${API_BASE_URL}/Import/${importType}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      setMessage(
        `✅ تمت العملية: الإجمالي ${res.data.totalRows}, المستورد ${res.data.imported}, المتخطى ${res.data.skipped}`
      );
    } catch (err) {
      console.error(err);
      setError("❌ حدث خطأ أثناء الاستيراد");
    }
  };

  // 🟢 زر لتوليد ملف Excel مثال
  const handleExportSample = () => {
    let sampleData = [];
    if (importType === 0) {
      // منتجات (9 أعمدة بالترتيب الصحيح)
      sampleData = [
        {
          "الاسم العربي": "منتج 1",
          "الاسم الإنجليزي": "Product 1",
          "الكود": "P001",
          "الباركود": "12345678901",
          "التصنيف": "مواد غذائية",
          "الوحدة": "حبة",
          "سعر الشراء": 80,
          "سعر البيع": 100,
        },
        {
          "الاسم العربي": "منتج 2",
          "الاسم الإنجليزي": "Product 2",
          "الكود": "P002",
          "الباركود": "12345678902",
          "التصنيف": "مشروبات",
          "الوحدة": "كرتون",
          "سعر الشراء": 50,
          "سعر البيع": 70,
        },
      ];
    } else if (importType === 1) {
      // عملاء
      sampleData = [
        {
          "الاسم العربي": "عميل تجريبي",
          "الرقم الضريبي" : "31111111100003",
          "رقم الجوال": "0500000000",
          "العنوان": "الرياض",
        },
      ];
    } else if (importType === 2) {
      // موردين
      sampleData = [
        {
          "الاسم العربي": "مورد تجريبي",
          "الرقم الضريبي ": "31111111100003",
          "رقم الجوال": "0555555555",
          "العنوان": "جدة",
        },
      ];
    }

    const ws = XLSX.utils.json_to_sheet(sampleData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sample");
    XLSX.writeFile(wb, "Import_Sample.xlsx");
  };

  return (
    <Container maxWidth="md" className="mt-6">
      <Card>
        <CardHeader title="📥 الاستيراد من Excel" />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                select
                label="نوع الاستيراد"
                value={importType}
                onChange={(e) => setImportType(e.target.value)}
              >
                <MenuItem value={0}>📦 المنتجات</MenuItem>
                <MenuItem value={1}>👤 العملاء</MenuItem>
                <MenuItem value={2}>🏭 الموردين</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                component="label"
                startIcon={<UploadFile />}
              >
                اختر ملف Excel
                <input
                  type="file"
                  hidden
                  accept=".xlsx, .xls"
                  onChange={(e) => setFile(e.target.files[0])}
                />
              </Button>
              {file && (
                <Typography variant="body2" className="mt-2">
                  📂 {file.name}
                </Typography>
              )}
            </Grid>

            {error && (
              <Grid item xs={12}>
                <Alert severity="error">{error}</Alert>
              </Grid>
            )}
            {message && (
              <Grid item xs={12}>
                <Alert severity="success">{message}</Alert>
              </Grid>
            )}

            <Grid item xs={12} className="flex gap-2">
              <Button
                variant="contained"
                color="success"
                startIcon={<SaveAlt />}
                onClick={handleImport}
              >
                استيراد
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                startIcon={<SaveAlt />}
                onClick={handleExportSample}
              >
                تصدير مثال Excel
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Container>
  );
}
